import { render, staticRenderFns } from "./option-fee-refundable.vue?vue&type=template&id=20623b9f"
import script from "./option-fee-refundable.vue?vue&type=script&lang=js"
export * from "./option-fee-refundable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports